/* eslint-disable @angular-eslint/no-empty-lifecycle-method */
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-version-check-dialog',
  templateUrl: './version-check-dialog.component.html',
  styleUrls: ['./version-check-dialog.component.scss']
})
export class VersionCheckDialogComponent implements OnInit {
  hideClose = true;
  constructor(private router: Router) { }

  ngOnInit(): void {}

  public reload(): void {
    const url = window.location.origin + window.location.pathname;
    window.location.href = `${url}?t=${Date.now()}`;
  }
}
